<mat-form-field fxFlex="100">
  <mat-label>{{ label }}</mat-label>

  <mat-select
    [value]="value"
    [disabled]="disabled"
    [required]="required"
    [placeholder]="placeholder"
    [compareWith]="compareByCode"
    (selectionChange)="changeValue($event.value)"
  >
    <mat-option [value]="null">
      Brak
    </mat-option>

    <mat-optgroup
      *ngIf="partnerItems.length"
      label="Kody partnerów">
      <mat-option
        *ngFor="let item of partnerItems"
        [value]="item.code">
        <div class="affiliate-code-option">
          <div class="affiliate-code-option__main">
            <strong>{{ item.code }}</strong>

            <span
              *ngIf="item.main"
              class="affiliate-code-option__badge">
              Główny
            </span>
          </div>

          <div class="affiliate-code-option__meta">
            {{ getOptionLabel(item) }}
          </div>
        </div>
      </mat-option>
    </mat-optgroup>

    <mat-optgroup
      *ngIf="ofwcaItems.length"
      label="Kody OFWCA (dodatkowe)">
      <mat-option
        *ngFor="let item of ofwcaItems"
        [value]="item.code">
        <div class="affiliate-code-option">
          <div class="affiliate-code-option__main">
            <strong>{{ item.code }}</strong>

            <span
              *ngIf="item.main"
              class="affiliate-code-option__badge">
              Główny
            </span>
          </div>

          <div class="affiliate-code-option__meta">
            {{ getOptionLabel(item) }}
          </div>
        </div>
      </mat-option>
    </mat-optgroup>

    <mat-option *ngIf="loadingOfwca" disabled>
      Ładowanie dodatkowych kodów OFWCA...
    </mat-option>

    <mat-option
      *ngIf="!loadingOfwca && !partnerItems.length && !ofwcaItems.length"
      disabled>
      Brak kodów dla partnerów i OFWCA przypisanych do placówki
    </mat-option>
  </mat-select>
</mat-form-field>
